/* ==========================================================================
   TRCO Cart Drawer · part B of 4 — open/close, cart refresh, render, line items
   ========================================================================== */
(function () {
  'use strict';
  var T = window.__trco; if (!T) return;
  var CONFIG = T.CONFIG, formatMoney = T.formatMoney, esc = T.esc, sizedImg = T.sizedImg,
      TAG_ICON = T.TAG_ICON, getJSON = T.getJSON, Ctrl = T.Ctrl;

  /* ---- open / close ----------------------------------------------------- */
  Ctrl.prototype.open = function () {
    if (this.el.classList.contains('is-open')) { this.startTimer(); return; }
    // Lock scroll without a layout jump: pad for the scrollbar we're about to hide.
    var sbw = window.innerWidth - document.documentElement.clientWidth;
    this.el.classList.add('is-open');
    this.el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('trco-cart-open');
    document.documentElement.style.overflow = 'hidden';
    if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
    // Force the semi-transparent backdrop to paint (it can render blank when the
    // host flips from visibility:hidden to visible). Double rAF = after first paint.
    var ov = this.$('.trco-cart__overlay');
    if (ov) {
      var paint = function () { ov.style.backgroundColor = getComputedStyle(ov).backgroundColor; };
      paint();
      requestAnimationFrame(function () { requestAnimationFrame(paint); });
    }
    this.startTimer();
  };
  Ctrl.prototype.close = function () {
    this.el.classList.remove('is-open');
    this.el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('trco-cart-open');
    document.documentElement.style.overflow = '';
    document.body.style.paddingRight = '';
    this.stopTimer();
  };

  /* ---- data refresh ----------------------------------------------------- */
  Ctrl.prototype.refresh = function (openAfter) {
    var self = this;
    // Slide the drawer in immediately (shows last-known content) so it never waits on the network.
    if (openAfter) this.open();
    return getJSON('cart.js').then(function (cart) {
      self.cart = cart;
      self.render();                          // show items as soon as cart.js returns
      return self.ensureCompareData(cart);    // fetch compare-at prices off the critical path
    }).then(function () {
      self.render();                          // re-render to add the savings badges
    }).catch(function () {});
  };

  // /cart.js does not expose compare-at on line items; fetch product .js per handle.
  Ctrl.prototype.ensureCompareData = function (cart) {
    var self = this;
    var handles = {};
    ((cart && cart.items) || []).forEach(function (it) { if (it.handle) handles[it.handle] = true; });
    var toFetch = Object.keys(handles).filter(function (h) { return !self.productCache[h]; });
    return Promise.all(toFetch.map(function (h) {
      return getJSON('products/' + h + '.js').then(function (p) {
        self.productCache[h] = p;
        (p.variants || []).forEach(function (v) { self.compareCache[v.id] = v.compare_at_price || null; });
      }).catch(function () { self.productCache[h] = { variants: [] }; });
    }));
  };

  // Fold just-added line item(s) from /cart/add.js into the cached cart so the
  // new item renders INSTANTLY; refresh() reconciles a moment later.
  Ctrl.prototype.applyAddedOptimistic = function (added) {
    if (!added || !added.length) return;
    var cart = this.cart || { items: [], item_count: 0, total_price: 0, note: '' };
    var items = (cart.items || []).slice();
    added.forEach(function (ai) {
      if (!ai) return;
      var idx = -1;
      for (var i = 0; i < items.length; i++) {
        if (ai.key && items[i].key === ai.key) { idx = i; break; }
      }
      if (idx === -1) items.push(ai);   // brand-new line
      else items[idx] = ai;             // add.js quantity is the merged line total
    });
    var next = {};
    for (var k in cart) { if (cart.hasOwnProperty(k)) next[k] = cart[k]; }
    next.items = items;
    next.item_count = items.reduce(function (n, it) { return n + (it.quantity || 0); }, 0);
    next.total_price = items.reduce(function (s, it) {
      return s + (it.final_line_price != null ? it.final_line_price : (it.final_price || it.price || 0) * (it.quantity || 0));
    }, 0);
    this.cart = next;
  };

  /* ---- render ----------------------------------------------------------- */
  Ctrl.prototype.render = function () {
    var cart = this.cart;
    var copy = CONFIG.copy || {};
    var addonVariant = CONFIG.addon && CONFIG.addon.variantId;
    var self = this;

    var visible = ((cart && cart.items) || []).filter(function (it) { return it.id !== addonVariant && it.variant_id !== addonVariant; });
    var isEmpty = visible.length === 0;

    // While an add is in flight and the cart still reads empty, show a spinner.
    if (isEmpty && this._loading) {
      this.emptyEl.hidden = true;
      this.itemsEl.hidden = false;
      this.itemsEl.innerHTML = '<div class="trco-cart__spinner" aria-label="Loading"></div>';
      this._lastItemsHTML = null;
      this.upsellsEl.hidden = true;
      this.footerEl.classList.add('is-hidden');
      this.timerEl.hidden = true;
      return;
    }
    if (!cart) return;

    this.emptyEl.hidden = !isEmpty;
    this.itemsEl.hidden = isEmpty;
    this.footerEl.classList.toggle('is-hidden', isEmpty);
    this.timerEl.hidden = isEmpty;

    if (isEmpty) {
      this.itemsEl.innerHTML = '';
      this._lastItemsHTML = null;
      this.upsellsEl.hidden = true;
      this._discountError = null;
      this.updateBubble(0);
      this.stopTimer();
      return;
    }

    // Only rewrite the line-items DOM when it actually changed (no image flicker).
    var itemsHTML = visible.map(function (it) { return self.itemHTML(it); }).join('');
    if (itemsHTML !== this._lastItemsHTML) {
      this.itemsEl.innerHTML = itemsHTML;
      this._lastItemsHTML = itemsHTML;
    }
    this.updateUpsells(cart);

    var addonInCart = (cart.items || []).some(function (it) { return it.id === addonVariant || it.variant_id === addonVariant; });
    if (this.addonEl) {
      this.addonEl.hidden = !addonVariant;
      if (this.addonToggle) this.addonToggle.checked = addonInCart;
    }

    if (this.noteEl && document.activeElement !== this.noteEl) this.noteEl.value = cart.note || '';

    if (this.checkoutTextEl) {
      this.checkoutTextEl.textContent = (copy.checkout || 'Checkout') + ' • ' + formatMoney(cart.total_price);
    }

    this.renderDiscount(cart);

    var count = visible.reduce(function (n, it) { return n + it.quantity; }, 0);
    this.updateBubble(count);
    this.renderTimer();
  };

  // Line item. Savings are measured from the "was" price (compare-at when the
  // variant is on sale, otherwise its regular price) down to the line's final
  // price after any discount code — so a compare-at sale, a code, or both
  // stacked all display the same way:  ~~was~~  now  (Save $X)
  Ctrl.prototype.itemHTML = function (it) {
    var copy = CONFIG.copy || {};
    var qty = it.quantity || 0;
    var compareAt = this.compareCache[it.id] || 0;
    var unitRegular = it.original_price != null ? it.original_price : (it.price || 0);
    var unitWas = Math.max(compareAt, unitRegular);
    var lineWas = unitWas * qty;
    var lineNow = it.final_line_price != null ? it.final_line_price : (it.final_price || it.price || 0) * qty;
    var savings = lineWas > lineNow ? lineWas - lineNow : 0;
    var hasSavings = savings > 0;
    var img = sizedImg(it.image, 160);

    var options = (it.options_with_values || []).filter(function (o) {
      return !(o.name === 'Title' && o.value === 'Default Title');
    }).map(function (o) {
      return '<div class="trco-item__option">' + esc(o.name) + ': ' + esc(o.value) + '</div>';
    }).join('');

    var props = '';
    if (it.properties) {
      for (var k in it.properties) {
        if (!it.properties.hasOwnProperty(k)) continue;
        if (CONFIG.hideUnderscoredProperties && k.charAt(0) === '_') continue;
        if (!it.properties[k]) continue;
        props += '<div class="trco-item__option">' + esc(k) + ': ' + esc(it.properties[k]) + '</div>';
      }
    }

    var priceBlock = '<div class="trco-item__prices">' +
      (hasSavings ? '<span class="trco-item__compare">' + formatMoney(lineWas) + '</span>' : '') +
      '<span class="trco-item__price">' + formatMoney(lineNow) + '</span>' +
      (hasSavings ? '<span class="trco-item__savings">(' + esc(copy.savingsLabel || 'Save') + ' ' + formatMoney(savings) + ')</span>' : '') +
      '</div>';

    // Name the code(s) behind a line discount, e.g. "VIP20 (−$25.33)".
    var codeTags = (it.line_level_discount_allocations || []).filter(function (a) {
      return a && a.amount > 0;
    }).map(function (a) {
      var title = (a.discount_application && a.discount_application.title) || copy.discountLabel || 'Discount';
      return '<div class="trco-item__discount">' + TAG_ICON + '<span>' + esc(title) + ' (−' + formatMoney(a.amount) + ')</span></div>';
    }).join('');

    return '' +
      '<div class="trco-item" data-line-key="' + esc(it.key) + '">' +
        '<div class="trco-item__media"><a href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(it.product_title) + '" loading="lazy">' : '') + '</a></div>' +
        '<div class="trco-item__info">' +
          '<a class="trco-item__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
          options + props + priceBlock + codeTags +
        '</div>' +
        '<div class="trco-item__right">' +
          '<button class="trco-item__remove" data-trco-remove data-key="' + esc(it.key) + '" aria-label="Remove">' +
            '<svg viewBox="0 0 24 24" width="16" height="16"><path d="M6 7h12M9 7V5h6v2m-8 0l1 12h8l1-12" stroke="currentColor" stroke-width="1.4" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '</button>' +
          '<div class="trco-qty">' +
            '<button data-trco-dec data-key="' + esc(it.key) + '" data-qty="' + it.quantity + '" aria-label="Decrease">−</button>' +
            '<span class="trco-qty__value">' + it.quantity + '</span>' +
            '<button data-trco-inc data-key="' + esc(it.key) + '" data-qty="' + it.quantity + '" aria-label="Increase">+</button>' +
          '</div>' +
        '</div>' +
      '</div>';
  };
})();